import React, { useMemo } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Maximize2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { JsonMetadataViewer } from "@/components/shared/JsonMetadataViewer";

interface OrderMetadataProps {
  metadata: Record<string, any> | null;
}

export function OrderMetadata({ metadata }: OrderMetadataProps) {
  const formattedMetadata = useMemo(
    () => metadata && JSON.stringify(metadata, null, 2),
    [metadata]
  );

  if (!metadata) return null;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <span className="font-medium">Metadata</span>
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="ghost" size="sm" className="gap-2">
              <Maximize2 className="h-4 w-4" />
              <span>Expand</span>
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-4xl w-full h-600 flex flex-col">
            <DialogHeader>
              <DialogTitle>Order Metadata</DialogTitle>
            </DialogHeader>
            <div className="flex-grow overflow-hidden">
              <JsonMetadataViewer 
                data={metadata}
                height="500px"
              />
            </div>
          </DialogContent>
        </Dialog>
      </CardHeader>
      <CardContent>
      <pre className="whitespace-pre-wrap text-xs bg-gray-50 p-4 rounded-md max-h-[100px] overflow-y-auto">
          {formattedMetadata}
        </pre>
          {/* <JsonMetadataViewer 
            data={metadata}
            height="200px"
          /> */}
      </CardContent>
    </Card>
  );
}
